module.exports = __webpack_public_path__ + "static/media/scroll-top-square.46bc384a.png";